"use strict";var e;exports.TokenType=void 0,(e=exports.TokenType||(exports.TokenType={})).ERC20="ERC20",e.ERC721="ERC721";
